import React, { Component } from 'react';
import PropTypes from 'prop-types';

// styles
import styles from './PdpRespPrintHeader.scss';

class PdpRespPrintHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            logoIcon: null,
        };
    }

    componentDidMount() {
        import(
            /* webpackChunkName: "PdpRespPrintHeaderLogo" */
            './PdpRespPrintHeaderLogo'
        ).then(logoIcon => {
            if (logoIcon) {
                this.setState(logoIcon);
            }
        });
    }

    render() {
        const { logoIcon } = this.state;
        const { className, itemId } = this.props;

        return (
            <div className={`${styles.wrap} ${className}`}>
                {logoIcon}
                <p className={styles.itemId}>{itemId}</p>
            </div>
        );
    }
}

PdpRespPrintHeader.propTypes = {
    itemId: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export { PdpRespPrintHeader };
